import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/modules/profile/profile.service';
import { AuthService } from '../../services/auth/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoginService } from 'src/app/modules/login/login.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchService } from 'src/app/modules/search/search.service';
import { NotificationService } from 'src/app/modules/notification/notification.service';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'life-di-nav',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  token: string = null;
  role: string = null;
  profile = null;
  path: string;
  searchForm: FormGroup;
  notibadge: number;
  notiArr = [];
  dates = new Date();
  second: number; // for realtime noti

  searchPath: string;
  filteredOptions: string[] = [];
  inputValue: string = '';
  options = [];
  suggestSearch = [];

  constructor(
    private authService: AuthService,
    private profileService: ProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private loginService: LoginService,
    private fb: FormBuilder,
    private searchService: SearchService,
    private notificationService: NotificationService
  ) {
    // this.token = this.authService.getToken();
    this.authService.token.subscribe(res => this.token = res);
    this.path = this.router.url.split('\/')[1];
    this.filteredOptions = this.suggestSearch;
  }

  ngOnInit() {
    this.searchPath = this.route.snapshot.routeConfig.path;

    this.searchForm = this.fb.group({
      input: ['', Validators.required]
    })

    if (this.token !== '') {
      this.profileService.getProfile().pipe(
        map(profile => {
          this.profile = profile;
        })
      ).subscribe(() => { }, err => {
        if (err.error.message === 'token not found') {
          this.cookieService.deleteAll();
          if (this.path === '') {
            location.reload()
          } else {
            this.router.navigate(['']);
          }
        }
      })

      this.getNoti();

      // this.searchService.getSuggestSearch().pipe(
      //   map(res => {
      //     this.suggestSearch = res.result;

      //     this.suggestSearch.forEach(element => {
      //       this.options.push(element.search_text);
      //     });
      //     // // console.log(this.options);
      //   })
      // ).subscribe();
      // } else {
      // setTimeout(() => {
      // this.searchService.getSuggestSearch().pipe(
      //   map(res => {
      //     this.suggestSearch = res.result;

      //     this.suggestSearch.forEach(element => {
      //       this.options.push(element.search_text);
      //     });
      //     // // console.log(this.options);
      //   }),
      // ).subscribe();
      // }, 1000);
    }
  }

  logout() {
    this.loginService.logout().pipe(
      switchMap(() => {
        return this.authService.deleteTokenLogout()
      }),
      map(() => {
        if (this.path === '') {
          location.reload()
        } else {
          this.router.navigate(['']).then(() => {
            location.reload()
          });
        }
      })
    ).subscribe()
  }

  searchClick() {
    const queryParams: Params = { keyword: this.inputValue };
    this.router.navigate(
      ['/search'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
  }

  onChange(value: string): void {
    this.filteredOptions = this.options.filter(option => option.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    // // console.log(value);
    this.inputValue = value;
  }

  getSuggestSearch() {
    this.searchService.getSuggestSearch().pipe(
      map(res => {
        // console.log(res);
        this.suggestSearch = res.result;

        this.suggestSearch.forEach(element => {
          this.options.push(element.search_text);
        });
        // // console.log(this.options);
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false)
      })
    ).subscribe();
  }

  getNoti() {
    let notification = this.notificationService.getAllNotificationByUser().pipe(
      switchMap(noti => {
        this.notiArr = noti.result.reverse();

        return this.notificationService.getAllNotiByType(0)
      }),
      map(notiBadge => {
        this.notibadge = notiBadge.result.length;
      })
    ).subscribe(() => {
      notification.unsubscribe();
    });
  }

  updateStatusNoti(noti) {
    let body = {
      ID: [noti.ID]
    };

    if (noti.NOTI_STATUS === 0) {
      // ยังไม่ได้อ่าน
      let notification = this.notificationService.updateStatusNoti(body).pipe(
        map(res => {
          this.getNoti();
        })
      ).subscribe(() => {
        notification.unsubscribe();
        if (noti.LINK)
          window.open(noti.LINK, "_self");
      });
    } else {
      // อ่านแล้ว
      if (noti.LINK) {
        window.open(noti.LINK, "_self");
      }
    }
  }

  viewNoti() {
    // for refresh dateTimeAgo pipe after click
    setTimeout(() => {
      this.second = Math.random() * 10;
    }, 1000);
  }

  getLength(arr) {
    return arr.length;
  }
}
